export const apiURL = 'https://hms.baggotcourt.com'
// export const apiURL = 'http://127.0.0.1:8000'